import { render, staticRenderFns } from "./SideMenuCards.vue?vue&type=template&id=0f4d9198&scoped=true&"
import script from "./SideMenuCards.vue?vue&type=script&lang=js&"
export * from "./SideMenuCards.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuCards.vue?vue&type=style&index=0&id=0f4d9198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d9198",
  null
  
)

export default component.exports